
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Layout from '@/components/layout/Layout';
import CommunityHero from '@/components/community/CommunityHero';
import CommunityStats from '@/components/community/CommunityStats';
import StaffsTab from '@/components/community/StaffsTab';
import MembersTab from '@/components/community/MembersTab';
import EventsTab from '@/components/community/EventsTab';
import NewsletterSection from '@/components/community/NewsletterSection';
import TranslatedText from '@/TranslatedText';

const Community: React.FC = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-[37px]">
        <CommunityHero />
        <CommunityStats />
        
        <Tabs defaultValue="staffs" className="mb-8">
          <TabsList className="mb-6 w-full justify-start overflow-x-auto">
            <TabsTrigger value="staffs" className="text-sm py-2 px-[7px]">
              <TranslatedText text="Staffs" />
            </TabsTrigger>
            <TabsTrigger value="members" className="text-sm py-2 px-[16px]">
              <TranslatedText text="Members" />
            </TabsTrigger>
            <TabsTrigger value="events" className="text-sm px-5 py-2">
              <TranslatedText text="Events" />
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="staffs">
            <StaffsTab />
          </TabsContent>
          
          <TabsContent value="members">
            <MembersTab />
          </TabsContent>
          
          <TabsContent value="events">
            <EventsTab />
          </TabsContent>
        </Tabs>
        
        <NewsletterSection />
      </div>
    </Layout>
  );
};

export default Community;
